import { createMemoizedSelector } from "@tecreation/js-state"

/**
 *
 * @returns the count of all added visitors
 */
export const selectVisitorCount = createMemoizedSelector(
	state => {
		return state.order.visitorKinds
	},
	visitorKinds => {
		return Object.keys(visitorKinds).reduce((o, n) => {
			return o + visitorKinds[n].cnt
		}, 0)
	},
)

/**



/**
 *
 * @returns {Array.<number>} An Array of all VisitorKindIds (including duplicates)
 */
export const selectVisitorKindIds = createMemoizedSelector(
	state => {
		return state.order.visitorKinds
	},
	visitorKinds => {
		let result = {}
		Object.keys(visitorKinds).forEach(key => {
			const entry = visitorKinds[key]
			for (let i = 0; i < entry.cnt; i++) {
				if (result[entry.visitor.visitorKindId]) {
					result[entry.visitor.visitorKindId]++
				} else {
					result[entry.visitor.visitorKindId] = 1
				}
			}
		})

		let rr = Object.keys(result).map(e => {
			return {
				visitorKindId: Number(e),
				quantity: result[e],
			}
		})
		return rr
	},
)

/**
 * Selects if the dateSelection is valid and the next button should be enabled
 * @returns
 */
export const selectIsDateSelectionValid = state => {
	return state.order.selectedDay && state.order.selectedTbKind && state.order.selectedTs
}

/**
 * Selects the price for the DateSelectionFooter, the price comes from the selected timeslot.
 *
 * If no timeslot is selected we return the minPrice of the timeblock, or the day or undefined
 * @param {*} state
 * @returns
 */
export const selectDateSelectionPrice = state => {
	if (state.order.selectedTb) {
		return state.order.selectedTb.price
	}
	if (state.order.selectedTbKind) {
		return state.order.selectedTbKind.minPrice
	}
	if (state.order.selectedDay) {
		return state.order.selectedDay.price || 0
	}
	return 0
}

export const selectFullPrice = state => {
	let base = selectDateSelectionPrice(state)
	return base + (state.order.loungers.reduce((c, v) => c + v.price, 0) || 0) + (state.order.productPrice || 0)
}

/*
 *
 * @returns the count of all added visitors
 */
export const selectNeededCapacity = createMemoizedSelector(
	state => {
		return state.order.visitorKinds
	},
	visitorKinds => {
		return Object.keys(visitorKinds).reduce((o, n) => {
			let add = 0
			const cnt = visitorKinds[n].cnt
			add = cnt
			return o + add
		}, 0)
	},
)

export const selectMinimumCapacity = createMemoizedSelector(
	state => {
		return state.order.visitorKinds
	},
	visitorKinds => {
		return Object.keys(visitorKinds).reduce((o, n) => {
			let add = 0
			const v = visitorKinds[n].visitor
			const cnt = visitorKinds[n].cnt
			if (v.hasObjectCapacity) {
				add = cnt
			}

			return o + add
		}, 0)
	},
)

export const selectUsedCapacity = createMemoizedSelector(
	state => {
		return state.order.loungers
	},
	loungers => {
		return loungers.reduce((acc, cLounger) => {
			return acc + cLounger.capacity
		}, 0)
	},
)

export const selectMissingCapacity = state => {
	const needed = selectNeededCapacity(state)
	const used = selectUsedCapacity(state)

	return needed - used
}

export const selectObjectGroups = createMemoizedSelector(
	state => {
		return state.order.loungers
	},
	loungers => {
		let objectGroupTypes = []
		loungers.forEach(e => {
			if (objectGroupTypes.indexOf(e.objectGroupId) === -1) {
				objectGroupTypes.push(e.objectGroupId)
			}
		})
		return objectGroupTypes
	},
)

export const isLoungerSelected = loungerId => {
	return createMemoizedSelector(
		state => {
			return state.order.loungers
		},
		loungers => {
			return loungers.filter(e => e.selectedId === loungerId).length > 0
		},
	)
}

export const selectCountOfLoungerWithSelection = createMemoizedSelector(
	state => {
		return state.order.loungers
	},
	loungers => {
		return loungers.filter(e => e.selectedId).length
	},
)

export const selectSelectedObjectIds = createMemoizedSelector(
	state => {
		return state.order.loungers
	},
	loungers => {
		return loungers.map(e => e.selectedId)
	},
)
